<template>
    <transition name="fade">
        <div v-if="isVisible" id="tip_popup" @click="closePopup">
            <div class="tip_popup" @click.stop>
                <div class="tip_popup1">{{ title }}</div>
                <div class="tip_popup2">
                    <div class="tip_popup4" v-for="(item, i) in tips" :key="i">
                        <div class="tip_popup6">{{ item.title }}</div>
                    </div>
                </div>
                <div class="tip_popup8 cursor_1" @click="closePopup">我知道了</div>
                <div class="t-p-t-10">
                    <el-checkbox v-model="checked"></el-checkbox>&nbsp;不再显示
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import data from '@/assets/data';
export default {
    props: {
        title: {
            type: String,
            default: '用户须知'
        },
        mode: {
            type: String,
            default: '章节'
        },
        name: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            tips: data.ktTip,
            isVisible: false,
            checked: false
        };
    },
    methods: {
        openPopup() {
            this.isVisible = true;
        },
        closePopup() {
            if (this.checked) {
                localStorage.setItem('kc_tip', true)
            }
            this.isVisible = false;
        },
    }
};
</script>

<style scoped>
#tip_popup {
    width: 100vw;
    height: 100vh;
    background: rgba(14, 14, 14, 0.2);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.tip_popup {
    background: url('@/assets/image/icon_tip1.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-flow: column;
    align-items: center; 
    padding: 18px 40px 10px;
}

.tip_popup1 {
    font-weight: bold;
    font-size: 25px;
    color: #000000;
}

.tip_popup2 {
    width: 500px;
    margin-top: 40px;
    padding-bottom: 112px;
    padding: 0 20px 100px 10px;
}

.tip_popup3 {
    font-size: 15px;
    color: #199BFF;
    margin-bottom: 15px;
}

.tip_popup4 {
    margin-bottom: 15px;
    line-height: 1.5;
}

.tip_popup5 {
    font-weight: bold;
    font-size: 17px;
    color: #333333;
}

.tip_popup6 {
    font-size: 18px;
    color: #444444;
    margin-top: 5px;
    position: relative;
}

.tip_popup6::before {
    position: absolute;
    content: '';
    left: -10px;
    top: 8px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: var(--tech-primary);
}

.tip_popup7 {
    font-size: 14px;
    color: #362615;
    display: flex;
    align-items: center;
    margin-top: 15px;
}

.tip_popup7 img {
    width: 15px;
    height: 15px;
    margin-right: 5px;
}

.tip_popup8 {
    width: 183px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    border-radius: 42px;
    font-size: 16px;
    color: #FFFFFF;
    margin-top: 15px;
    cursor: pointer;
    background: linear-gradient(to right, #0089ff, #005bac);
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>